import type { GridColumn } from '@glideapps/glide-data-grid';

import { CurrencyISO } from '@/constants/currencies';

export const COLUMNS: GridColumn[] = [
  {
    title: 'Ticker',
    id: 'ticker',
    grow: 1,
  },
  {
    title: 'Date',
    id: 'date',
    grow: 1,
  },
  {
    title: 'Shares',
    id: 'shares',
    grow: 1,
  },
  {
    title: 'Price',
    id: 'price',
    grow: 1,
  },
  {
    title: 'Cost',
    id: 'cost',
    grow: 1,
  },
  {
    title: 'Type',
    id: 'type',
    grow: 1,
  },
];

export type ColumnId = (typeof COLUMNS)[number]['id'];

export const COLUMN_IDS: ColumnId[] = [
  'ticker',
  'date',
  'shares',
  'price',
  'cost',
  'type',
];

export type Row = {
  ticker: string | null;
  date: Date | null;
  shares: number | null;
  price: number | null;
  cost: number | null;
  type: string | null;
  currencyISO: CurrencyISO | null;
};
